"use client";

import Image from "next/image";
import { FC } from "react";
import { cn } from "@litonarefin/utils/index";

type Props = {
  url: string;
  className?: string;
};

const AISummarize: FC<Props> = ({ url, className }) => {
  const prompt = `Summarize this article:

${url}

Please provide:
- A short summary
- Step-by-step instructions
- Key takeaways
- Important notes or warnings`;

  const aiLinks = {
    chatgpt: `https://chatgpt.com/?prompt=${encodeURIComponent(prompt)}`,
    claude: `https://claude.ai/new?q=${encodeURIComponent(prompt)}`,
    perplexity: `https://www.perplexity.ai/?q=${encodeURIComponent(prompt)}`,
    gemini: `https://gemini.google.com/app?q=${encodeURIComponent(prompt)}`,
    googleAiMode: `https://www.google.com/aimode?q=${encodeURIComponent(prompt)}`,
    deepseek: `https://chat.deepseek.com/?q=${encodeURIComponent(prompt)}`,
  };

  return (
    <div className={ cn("jlt-flex jlt-items-center jlt-gap-2", className) }>
      <a
        href={aiLinks.chatgpt}
        target="_blank"
        rel="noopener noreferrer"
        title="ChatGPT AI Overview"
        className="jlt-border jlt-rounded-md jlt-p-2 hover:jlt-bg-slate-100 jlt-duration-150"
      >
        <Image src={"/ai/chatgpt.svg"} width={20} height={20} alt="ChatGPT Icon" />
      </a>
      <a
        href={aiLinks.claude}
        target="_blank"
        rel="noopener noreferrer"
        title="Claude AI Overview"
        className="jlt-border jlt-rounded-md jlt-p-2 hover:jlt-bg-slate-100 jlt-duration-150"
      >
        <Image src={"/ai/claude.webp"} width={20} height={20} alt="Claude Icon" />
      </a>
      <a
        href={aiLinks.perplexity}
        target="_blank"
        rel="noopener noreferrer"
        title="Perplexity AI Overview"
        className="jlt-border jlt-rounded-md jlt-p-2 hover:jlt-bg-slate-100 jlt-duration-150"
      >
        <Image src={"/ai/perplexity.svg"} width={20} height={20} alt="Perplexity Icon" />
      </a>
      {/* <a
        href={aiLinks.gemini}
        target="_blank"
        rel="noopener noreferrer"
        title="Gemini AI Overview"
        className="jlt-border jlt-rounded-md jlt-p-2 hover:jlt-bg-slate-100 jlt-duration-150"
      >
        <Image src={"/ai/gemini.svg"} width={20} height={20} alt="Gemini Icon" />
      </a> */}
      <a
        href={aiLinks.googleAiMode}
        target="_blank"
        rel="noopener noreferrer"
        title="Gemini AI Overview"
        className="jlt-border jlt-rounded-md jlt-p-2 hover:jlt-bg-slate-100 jlt-duration-150"
      >
        <Image src={"/ai/gemini.svg"} width={20} height={20} alt="Gemini Icon" />
      </a>
      <a
        href={aiLinks.deepseek}
        target="_blank"
        rel="noopener noreferrer"
        title="Deepseek AI Overview"
        className="jlt-border jlt-rounded-md jlt-p-2 hover:jlt-bg-slate-100 jlt-duration-150"
      >
        <Image src={"/ai/deepseek.webp"} width={20} height={20} alt="Deepseek Icon" />
      </a>
    </div>
  );
};

export default AISummarize;
